<div class="loader">
    <ng-container *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7]">
        <div class="side"></div>
    </ng-container>
</div>
